import { t } from 'i18next'

export enum NotificationReason {
  EMPLOYEE_VACATION_CREATED = 'EMPLOYEE_VACATION_CREATED',
  EMPLOYEE_VACATION_CHANGED = 'EMPLOYEE_VACATION_CHANGED',
  EMPLOYEE_UPCOMING_VACATION = 'EMPLOYEE_UPCOMING_VACATION',
  EMPLOYEE_APPROVED_VACATION = 'EMPLOYEE_APPROVED_VACATION',
  WORK_HOURS_NOT_FILLED = 'WORK_HOURS_NOT_FILLED',
  MONTH_SUMMARY = 'MONTH_SUMMARY',
  ADMINISTRATION_NOTIFICATION = 'ADMINISTRATION_NOTIFICATION',
  NEW_EMPLOYEE_ADDED = 'NEW_EMPLOYEE_ADDED',
  NEW_CANDIDATE_COMMENT = 'NEW_CANDIDATE_COMMENT',
  CONTRACT_EXPIRING = 'CONTRACT_EXPIRING',
  OWN_CONTRACT_EXPIRING = 'OWN_CONTRACT_EXPIRING',
}

export type NotificationReasonItem = {
  key: NotificationReason
  label: string
}

export const notificationsReasonArray: NotificationReasonItem[] = [
  {
    key: NotificationReason.EMPLOYEE_VACATION_CREATED,
    label: t('components.notificationSidebar.filtering.adding_vacation'),
  },
  {
    key: NotificationReason.EMPLOYEE_UPCOMING_VACATION,
    label: t('components.notificationSidebar.filtering.upcoming_vacation'),
  },
  {
    key: NotificationReason.EMPLOYEE_APPROVED_VACATION,
    label: t('components.notificationSidebar.filtering.vacation_confirmation'),
  },
  { key: NotificationReason.WORK_HOURS_NOT_FILLED, label: t('components.notificationSidebar.filtering.missing_hours') },
  { key: NotificationReason.MONTH_SUMMARY, label: t('components.notificationSidebar.filtering.month_summary') },
  {
    key: NotificationReason.ADMINISTRATION_NOTIFICATION,
    label: t('components.notificationSidebar.filtering.administrative_notification'),
  },
  { key: NotificationReason.NEW_EMPLOYEE_ADDED, label: t('components.notificationSidebar.filtering.adding_employee') },
  {
    key: NotificationReason.NEW_CANDIDATE_COMMENT,
    label: t('components.notificationSidebar.filtering.adding_comment'),
  },
  {
    key: NotificationReason.CONTRACT_EXPIRING,
    label: t('components.notificationSidebar.filtering.expiring_contract'),
  },
  {
    key: NotificationReason.OWN_CONTRACT_EXPIRING,
    label: t('components.notificationSidebar.filtering.expiring_own_contract'),
  },
]
